export const ERROR_TRANSLATION_PREFIX = 'notifications';
export const ERROR_TRANSLATION_TITLE_SUFFIX = 'title';
export const ERROR_TRANSLATION_DESCRIPTION_SUFFIX = 'description';
export const ERROR_TRANSLATION_BUTTON_TEXT_SUFFIX = 'buttonText';

export enum ErrorType {
  ERRORS = 'errors',
  GENERIC_ERROR = 'genericErrors',
}
